import { config } from "@/lib/shared/config";
import { CliError } from "@/lib/cli/cli-error";
import { isHttpUrl } from "@/lib/http/is-http-url";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export function resolveLoginBaseUrl(parsed: ParsedArgs): string {
  const requested = parsed.flags.url?.trim();
  if (requested !== undefined && !isHttpUrl(requested)) {
    throw new CliError(`--url is not a valid http(s) URL: "${requested}".`, 2);
  }
  return (requested ?? config.load().baseUrl).replace(/\/$/, "");
}
